import React from "react";
import { CheckIcon } from "lucide-react";
import { bookContents } from "../data/content";
export function BookContents() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-27" data-mp="2z7etxpy8hfz1">
      <div className="mx-auto grid max-w-5xl items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-28" data-mp="2lfqfvh4fchff">
        <div data-id="element-29" data-mp="2qekzgla7ua0l">
          <h2 className="font-display text-3xl uppercase leading-tight text-cream sm:text-5xl" data-id="element-30" data-mp="2qe1pprupyrxn">
            Tout est dans <span className="text-gold" data-id="element-31" data-mp="2bh0ydpgfwyzp">un seul livre</span>
          </h2>
          <p className="mt-3 font-serif text-lg italic text-mute sm:mt-4 sm:text-xl" data-id="element-32" data-mp="2gihz9kyxclga">
            La méthode complète pour préparer, enseigner et faire progresser vos élèves.
          </p>
          <ul className="mt-8 space-y-5" data-id="element-33" data-mp="27fyyr7im2kx7">
            {bookContents.map(item => <li key={item.title} className="flex gap-3" data-id="element-34" data-mp="pre5pdz34l9">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold text-ink" data-id="element-35" data-mp="o7xhxoemriy">
                  <CheckIcon className="h-4 w-4" aria-hidden data-id="element-36" data-mp="3t59tpuubmnc" />
                </span>
                <div data-id="element-37" data-mp="3r0zoq6clrem">
                  <h3 className="font-bold text-cream sm:text-lg" data-id="element-38" data-mp="3vxpmxynj6omw">{item.title}</h3>
                  <p className="mt-1 text-sm text-mute sm:text-base" data-id="element-39" data-mp="dj6x4ffdd117">{item.desc}</p>
                </div>
              </li>)}
          </ul>
        </div>
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/c21669ff-0451-4e1c-9b07-e8204e066496.jpg" alt="Aperçu des pages du livre : tablatures, calendrier et partitions" className="w-full rounded-2xl" data-id="element-40" data-mp="8kvp8a8mx0lm" />
      </div>
    </section>;
}